import { api } from './api';
import type { GoalMetric } from '../../shared/stats';

export async function copyGoalPeriods(periods: readonly ('month' | 'quarter')[]): Promise<void> {
  for (const period of periods) await api('/api/admin/stats/goals/copy-last-period', { method: 'POST', json: { period } });
}

export async function keepGoal(periodKey: string, metric: GoalMetric, target: number): Promise<void> {
  await api('/api/admin/stats/goals', { method: 'PUT', json: { period_key: periodKey, metric, target } });
}
